import axios, { AxiosInstance } from 'axios';
import AxiosRepository from './axios.repository';
import { FmsSyncTasks, IAdminFacilitiesListParams, IDropdownOption, IFacilityRepository } from '@common/interfaces';
import { decoupledClientInstance } from '@common/utils/axios';

class FacilityRepository extends AxiosRepository implements IFacilityRepository {
  public constructor(protected authClient: AxiosInstance) {
    super((decoupledClientInstance as any).create(), authClient);
  }

  // Note: get locally with clean instance of axios
  async getGeoJSON() {
    const { data } = await axios.get('/countries.geo.json');
    return data;
  }

  async getFacilities() {
    const { data } = await this.get('/facilities/');
    return data;
  }

  async getActiveFacilities(managedFacilities: IDropdownOption[]) {
    const ids = managedFacilities.map((f) => Number(f.value));
    const { data } = await this.post('/facilities/active/', { facilities: ids });
    return managedFacilities.filter((f) => data.facilities.includes(Number(f.value)));
  }

  async getFacility(facilityId: string) {
    const { data } = await this.get(`/facilities/${facilityId}/`);
    return data;
  }

  async getFocalPoints(facilityId: string) {
    // Note: if we need more focal points - we should make loading options
    const { data } = await this.get(`/facilities/${facilityId}/focal-points/`, {
      params: {
        limit: 100,
      },
    });
    return data;
  }

  async getAdminFacilities(params?: IAdminFacilitiesListParams) {
    const { data } = await this.get(`/facilities/management/`, { params });
    return data;
  }

  async createAdminFacility(payload: FormData) {
    const { data } = await this.post('facilities/management/', payload);
    return data;
  }

  async getAdminFacility(facilityId: string) {
    const { data } = await this.get(`/facilities/management/${facilityId}/`);
    return data;
  }

  async patchAdminFacility(facilityId: string, payload: FormData) {
    const { data } = await this.patch(`/facilities/management/${facilityId}/`, payload);
    return data;
  }

  async getAdminFacilitiesFilters() {
    const { data } = await this.get('/facilities/management/filters/');
    return data;
  }

  async getAdminFacilitiesOptions() {
    const { data } = await this.get('/facilities/management/options/');
    return data;
  }

  async getAdminFacilitiesBookings(uuid: string) {
    const { data } = await this.get(`/facilities/management/${uuid}/bookings/`);
    return data;
  }

  async getSyncFmsData(task_name: FmsSyncTasks) {
    const { data } = await this.get(`/facilities/sync/${task_name}/`);
    return data;
  }

  async syncFmsData(task_name: FmsSyncTasks) {
    const { data } = await this.post(`/facilities/sync/${task_name}/`);
    return data;
  }

  async exportFacilities() {
    const { data } = await this.get('/facilities/export/', {
      responseType: 'blob',
    });
    return new File([data], `facilities_list.xls`);
  }
}

export default FacilityRepository;
